import { useContext, useState } from 'react'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useRestApi } from '../../../lib/RestApi/useRestApi'
import { API_URL } from '../../../shared/actions'

export const useContentQuestion = () => {
  const [contentQuestion, setContentQuestion] = useState(false)
  const { deleteNewContentQuestion, getNewContentQuestion } = useContext(OtherContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Training Category', 'ALL_CONTENTQUESTION', 'GET_ALL_CONTENTQUESTION')
  const {
    CONTENTQUESTION: { GET_ALL_CONTENTQUESTION, ADD_CONTENTQUESTION, EDIT_CONTENTQUESTION, DELETE_MANY_CONTENTQUESTION },
  } = API_URL

  const getAllContentQuestion = async (dto = {}) => {
    GET_ALL(GET_ALL_CONTENTQUESTION, setPaginate, getNewContentQuestion, dto)
  }

  const addContentQuestion = (dto) => {
    ADD(ADD_CONTENTQUESTION, dto)
  }

  const updateContentQuestion = (dto) => {
    UPDATE(EDIT_CONTENTQUESTION, dto)
  }

  const getContentQuestion = (dto) => {
    GET_SINGLE_DATA(GET_ALL_CONTENTQUESTION, setContentQuestion, dto)
  }

  const deleteManyContentQuestion = (dto, setSelected = () => {}) => {
    console.log({ dto })
    DELETE(DELETE_MANY_CONTENTQUESTION, dto, 'contentQuestionId', setSelected, deleteNewContentQuestion, 'GET_ALL_CONTENTQUESTION')
  }

  return {
    addContentQuestion,
    getAllContentQuestion,
    getContentQuestion,
    contentQuestion,
    updateContentQuestion,
    deleteManyContentQuestion,
    loading,
    paginate,
  }
}
